import React from "react";
import { Skeleton } from "../common/LoadingSkeleton";

export const ProductDetailSkeleton: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 bg-background-light dark:bg-background-dark min-h-screen">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Image Gallery Skeleton */}
        <div>
          <Skeleton className="w-full aspect-square rounded-xl mb-4" />
          <div className="grid grid-cols-4 gap-2">
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} className="w-full aspect-square rounded-lg" />
            ))}
          </div>
        </div>

        {/* Product Info Skeleton */}
        <div>
          <Skeleton height="2rem" width="80%" className="mb-4" />
          <Skeleton height="1.5rem" width="40%" className="mb-6" />
          <div className="space-y-3 mb-6">
            <Skeleton height="1rem" width="100%" />
            <Skeleton height="1rem" width="90%" />
            <Skeleton height="1rem" width="95%" />
          </div>
          <Skeleton height="3rem" width="60%" className="mb-6" />
          <Skeleton height="12rem" width="100%" className="mb-6" />
        </div>
      </div>
    </div>
  );
};

